import { ReactNode } from 'react';

import { AppBackdrop } from '@/components/AppBackdrop';
import { MobileAppTopBar } from '@/components/MobileAppTopBar';
import { MobileTabBar } from '@/components/MobileTabBar';
import { ScrollToTopButton } from '@/components/ScrollToTopButton';
import { CreateFabProvider } from '@/contexts/CreateFabContext';
import { DueTrainingCountProvider } from '@/contexts/DueTrainingCountContext';
import { appShellScrollFrame } from '@/services/scrollFrame';

export function AppShell({ children }: { children: ReactNode }) {
  // Each page draws its own AppTopHeader on desktop; mobile gets MobileAppTopBar + MobileTabBar
  // here instead.
  return (
    <DueTrainingCountProvider>
      <CreateFabProvider>
        {/* No background fill here: the base colour comes from `body`, which lets AppBackdrop sit
            underneath the whole shell at z-index -10. */}
        <div
          className="flex min-h-dvh"
          data-app-shell
          // Nudged down while a card expands, so the shell keeps looking like the top of the page
          // even though the window still holds the list's scroll position. Relative, not transform:
          // it leaves the fixed backdrop, tab bar and scroll-to-top button viewport-anchored.
          style={appShellScrollFrame.offset ? { position: 'relative', top: appShellScrollFrame.offset } : undefined}
        >
          <AppBackdrop />
          <MobileTabBar className="md:hidden" />
          <div className="flex min-w-0 flex-1 flex-col">
            <MobileAppTopBar className="md:hidden" />
            {children}
          </div>
          <ScrollToTopButton />
        </div>
      </CreateFabProvider>
    </DueTrainingCountProvider>
  );
}
